import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import I18n from "../../../i18n/utils";
import { Link } from "react-router-dom";
import "./landing.scss";
import { RootState } from "../../redux/store/store";
import { Card, Col, Container, Row } from "reactstrap";
import TopNavBar from "../TopNavBar/TopNavBar";
import deliveryIcon from "../../assets/icons/delivery-car.svg";
import magnifyingClassIcon from "../../assets/icons/magnifying-glass-navy.svg";
import { getOktaUser, getUserPermissions } from "../../utils/LocalStorage";
import {
  businessSelector,
  fetchBusinessUnits,
} from "../../redux/features/businessSlice";
import { FAILED, IDLE, NEEDS_REFRESH } from "../../redux/features/constants";
import {
  deliveryPartnerCommissionRateHistorySelector,
  deliveryPartnerSelector,
  fetchDeliveryPartners,
} from "../../redux/features/deliveryPartnerSlice";
import { SetAGGridsLicense } from "../../hooks/setAGGridsLicense";

const Landing: React.FC = (): JSX.Element => {
  //TODO find a way to make sure this is always set even on refresh
  SetAGGridsLicense();

  const oktaUserInfo = getOktaUser();
  const [errorMessage, setErrorMessage] = useState<string>("");

  const businessFetchError = useSelector(
    (state: RootState) => state.businessUnits.error
  );
  const businessReduxStatus = useSelector(
    (state: RootState) => state.businessUnits.status
  );
  const businessUnits = useSelector(businessSelector);
  const deliveryPartnersFetchError = useSelector(
    (state: RootState) => state.deliveryPartners.error
  );
  const deliveryPartnersReduxStatus = useSelector(
    (state: RootState) => state.deliveryPartners.deliveryPartnerStatus
  );
  const deliveryPartners = useSelector(deliveryPartnerSelector);
  const deliveryPartnerCommissionRateHistoryList = useSelector(
    deliveryPartnerCommissionRateHistorySelector
  );
  const dispatch = useDispatch();

  // Temp hardcoded state variables
  // TODO implement state management for the following
  let loading = false;

  // Armored car UI has been disabled, so commenting out this initial data load
  // useEffect(() => {
  //   if (businessReduxStatus === IDLE || businessReduxStatus === NEEDS_REFRESH) {
  //     dispatch(fetchBusinessUnits());
  //   }
  //   if (businessReduxStatus === FAILED) {
  //     setErrorMessage(businessFetchError);
  //   }
  // }, [dispatch, businessReduxStatus, businessFetchError]);

  //TODO is there any need for Location API integration? seems it is not used anywhere in the legacy dashboard
  // useEffect(() => {
  //         // load locations into redux store
  //         if (locationReduxStatus === IDLE || locationReduxStatus === NEEDS_REFRESH) {
  //             dispatch(fetchLocations());
  //         }
  //         if(locationReduxStatus === FAILED){
  //             setErrorMessage(locationsFetchError);
  //         }
  // }, [locationReduxStatus, dispatch, locationsFetchError])

  useEffect(() => {
    if (
      deliveryPartnersReduxStatus === IDLE ||
      deliveryPartnersReduxStatus === NEEDS_REFRESH
    ) {
      dispatch(fetchDeliveryPartners());
    }
    if (deliveryPartnersReduxStatus === FAILED) {
      setErrorMessage(deliveryPartnersFetchError);
    }
  }, [dispatch, deliveryPartnersReduxStatus, deliveryPartnersFetchError]);

  return (
    <>
      <TopNavBar />
      <Container className="Landing">
        {!loading && (
          <>
            {oktaUserInfo && (
              <Row>
                <Col>
                  <h1 className="landing-greeting">
                    {I18n.t("APP_LANDING_PAGE_WELCOME")},<br></br>
                    <span>{oktaUserInfo[0]}</span>
                  </h1>
                  <h2 className="landing-message">
                    {I18n.t("APP_LANDING_PAGE_SELECT_APP")}
                  </h2>
                </Col>
              </Row>
            )}

            <Row style={{ justifyContent: "center", margin: "auto" }}>
              <Col md={4}>
                <DeliveryPartners />
              </Col>
              <Col md={4}>
                <RiskAnalysis />
              </Col>
              {/*<Col md={4}>*/}
              {/*  <ArmoredCar />*/}
              {/*</Col>*/}
            </Row>
          </>
        )}
      </Container>
    </>
  );
};

function ArmoredCar() {
  const treasuryPermissions = getUserPermissions();
  if (
    treasuryPermissions != null &&
    (treasuryPermissions.hasOwnProperty("ARMORED_CAR_LOGIN") ||
      treasuryPermissions.hasOwnProperty("ARMORED_CAR_ADMIN") ||
      treasuryPermissions.hasOwnProperty("SUPERUSER"))
  ) {
    return (
      <Col className={"card-column"}>
        <Card className="app-card">
          <Link
            to="/armored-car"
            className="card-link"
            data-cy="armored-car-link"
          >
            <h3>{I18n.t("APP_ARMORED_CAR_TITLE")}</h3>
            <Col className="container">
              <img
                alt=""
                className="app-card-icon delivery-icon"
                src={deliveryIcon}
              />
            </Col>
          </Link>
        </Card>
      </Col>
    );
  } else {
    return null;
  }
}

function DeliveryPartners() {
  const treasuryPermissions = getUserPermissions();
  if (
    treasuryPermissions != null &&
    (treasuryPermissions.hasOwnProperty("D_PARTNER_LOGIN") ||
      treasuryPermissions.hasOwnProperty("D_PARTNER_ADMIN") ||
      treasuryPermissions.hasOwnProperty("SUPERUSER"))
  ) {
    return (
      <Col className={"card-column"}>
        <Card className="app-card">
          <Link
            to="/delivery-partners"
            className="card-link"
            data-cy="delivery-partners-link"
          >
            <h3>{I18n.t("APP_DELIVERY_PARTNERS_TITLE")}</h3>
            <Col className="container">
              <img
                alt=""
                className="app-card-icon delivery-icon"
                src={deliveryIcon}
              />
            </Col>
          </Link>
        </Card>
      </Col>
    );
  } else {
    return null;
  }
}

function RiskAnalysis() {
  const treasuryPermissions = getUserPermissions();
  if (
    treasuryPermissions != null &&
    (treasuryPermissions.hasOwnProperty("RISK_ANALYSIS") ||
      treasuryPermissions.hasOwnProperty("SUPERUSER"))
  ) {
    return (
      <Col className={"card-column"}>
        <Card className="app-card">
          <Link
            to="/risk-analysis"
            className="card-link"
            data-cy="risk-analysis-link"
          >
            <h3>{I18n.t("APP_RISK_ANALYSIS_TITLE")}</h3>
            <img
              alt=""
              className="app-card-icon delivery-icon"
              src={magnifyingClassIcon}
            />
          </Link>
        </Card>
      </Col>
    );
  } else {
    return null;
  }
}
export default Landing;
